import type { EmailNew, NewStructureContact } from './ContactAdapterTypes';
import type { Email } from './ContactTypes';
import { isContactInvalid, isContactMain, isContactUndefined } from './ContactService';
import { isNewEmail } from './ContactAdapterService';
import { selectContacts } from './useContacts';

const transEmailContactToEmail = ({ id, flags, email }: EmailNew): Email => ({
    id,
    address: email?.address ?? '',
    isMainContact: isContactMain(flags),
    isInvalid: isContactInvalid(flags),
    isUndefined: isContactUndefined(flags),
});

export function getEmailsFromContacts(contacts: NewStructureContact[]): Email[] {
    return contacts.filter(isNewEmail).map(transEmailContactToEmail);
}

export function getEmails(): Email[] {
    return getEmailsFromContacts(selectContacts());
}

export const transformNewStructureEmailToEmail = (email: EmailNew): Email =>
    transEmailContactToEmail(email);
